// components/EmployeeDashboard.js
import * as React from 'react';
import { Box, Typography } from '@mui/material';
import '../static/App.css';

const EmployeeDashboard = () => {
    return (
        <div className='page-back'>
            <div className='container white-page'>
                <Box sx={{ px: 3, py: 5 }}>
                    <Typography variant="h3" color="#1b8fc9" gutterBottom>Welcome User</Typography>
                    <Typography sx={{ mb: 4 }}>Welcome to your dashboard! This is a mock page for now.</Typography>

                    {/* --- Dashboard Boxes --- */}
                    <Box sx={{ display: 'flex', gap: 4, flexWrap: 'wrap' }}>
                        <Box sx={{
                            flex: 1, minWidth: 250, height: 200, border: '2px solid #ddd', borderRadius: 3, 
                            backgroundColor: '#f5f5f5', display: 'flex', alignItems: 'center', justifyContent: 'center', 
                            fontSize: '1.5rem', fontWeight: 'bold', cursor: 'pointer', transition: 'all 0.3s',
                            '&:hover': { backgroundColor: '#e0f7fa', transform: 'scale(1.05)' }}}>
                            Learning Modules
                        </Box>

                        <Box sx={{
                            flex: 1, minWidth: 250, height: 200, border: '2px solid #ddd', borderRadius: 3, 
                            backgroundColor: '#f5f5f5', display: 'flex', alignItems: 'center', justifyContent: 'center', 
                            fontSize: '1.5rem', fontWeight: 'bold', cursor: 'pointer', transition: 'all 0.3s',
                            '&:hover': { backgroundColor: '#e0f7fa', transform: 'scale(1.05)' }}}>
                            Quizzes
                        </Box>
                    </Box>
                </Box>
            </div>
        </div>
    );
};

export default EmployeeDashboard;
